import { useState } from 'react';
import clsx from 'clsx';
import { FAQ_SECTIONS } from '@/lib/faq';
import { useBackNavigation } from '@/hooks/useBackNavigation';
import { haptic } from '@/lib/telegram';
import styles from './FaqPage.module.css';

export const FaqPage = () => {
  const goBack = useBackNavigation();
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    haptic.light();
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => { haptic.light(); goBack(); }}
        aria-label="Назад"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>

      <header className={styles.header}>
        <p className={styles.eyebrow}>Справка</p>
        <h1 className={styles.title}>Как пользоваться</h1>
        <p className={styles.subtitle}>
          Ответы на частые вопросы о ставках, автоставке, сделках и уведомлениях бота.
        </p>
      </header>

      <div className={styles.content}>
        {FAQ_SECTIONS.map((section) => (
          <section key={section.id} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <div className={styles.items}>
              {section.items.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div
                    key={item.id}
                    className={clsx(styles.item, isOpen && styles.itemOpen)}
                  >
                    <button
                      type="button"
                      className={styles.question}
                      onClick={() => toggle(item.id)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.question}</span>
                      <svg
                        className={clsx(styles.chevron, isOpen && styles.chevronOpen)}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                    {isOpen && <p className={styles.answer}>{item.answer}</p>}
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};
